import { handleActions } from 'redux-actions';

const reducer = handleActions(
    {
        SET_GLOBAL_STYLE: () => ({ globalStyleSet: true }),
    },
    { globalStyleSet: false },
);

export default reducer;
